import { Table, Loading } from "components";
import { useRoleManagementContext } from "context";
import { useState } from "react";
import { MessageModal, DeleteModal } from "features/Modal";
import { Role } from "helpers";
import { useAppDispatch } from "app/hooks";
import { setSelectedRole } from "services/roleSlice";
import { transformError, useDeleteRoleMutation } from "services";
import { RoleTableHeadings } from "./components/RoleTableHeadings";
import { RoleTableData } from "./components/RoleTableData";
import { RoleTableEditRoleModal } from "./components/RoleTableEditRoleModal";
import { t } from "i18next";

export const RoleTable = () => {
  const dispatch = useAppDispatch();
  const { data, isSuccess, page, onFetch, setPage } = useRoleManagementContext();
  const [deleteRole, deleteRoleResult] = useDeleteRoleMutation();
  const [openEditRoleModal, setOpenEditRoleModal] = useState<boolean>(false);
  const [deletingRole, setDeletingRole] = useState<Role | undefined>(undefined);
  const [openDeleteRoleModal, setOpenDeleteRoleModal] = useState<boolean>(false);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);

  const openEditModal = (role: Role) => {
    dispatch(setSelectedRole(role));
    setOpenEditRoleModal(true);
  };

  const openDeleteModal = (role: Role) => {
    setDeletingRole(role);
    setOpenDeleteRoleModal(true);
  };

  const onDeleteRole = async () => {
    if (deletingRole) {
      const stringCompanyId = typeof deletingRole.id === "number" ? deletingRole.id.toString() : deletingRole.id;
      try {
        await deleteRole({ id: deletingRole.id, company_id: stringCompanyId }).unwrap();
        setOpenDeleteRoleModal(false);
        if (data && data.data.length > 1) {
          onFetch();
        } else {
          setPage((prevPage) => prevPage - 1);
        }
        setOpenSuccessModal(true);
      } catch (error) {
        console.error(transformError(error).message);
      }
    }
  };

  return (
    <>
      {isSuccess && !!data ? (
        <>
          <Table
            headings={<RoleTableHeadings />}
            data={<RoleTableData onEdit={openEditModal} onDelete={openDeleteModal} />}
            // page={data.currentPage - 1} // TODO: check this !!
            page={page}
            pageCount={data.totalPages}
            onPageChange={({ selected }) => setPage(selected)}
            className="h-[650px]"
          />
          {openEditRoleModal && (
            <RoleTableEditRoleModal
              open={openEditRoleModal}
              setOpen={() => {
                onFetch();
                setOpenEditRoleModal(false);
                dispatch(setSelectedRole({}));
              }}
            />
          )}
          {openDeleteRoleModal && deletingRole && (
            <DeleteModal
              open={openDeleteRoleModal}
              setOpen={setOpenDeleteRoleModal}
              title={`${t("roleManagement.youAreAboutToDelete")} ${deletingRole.name}`}
              label={
                <>
                  {t("roleManagement.iUnderstandAction")} <span className="underline">{t("roleManagement.not")}</span>{" "}
                  {t("roleManagement.beUndone")}.
                </>
              }
              name={deletingRole.name}
              isLoading={deleteRoleResult.isLoading}
              onSave={onDeleteRole}
            />
          )}
          {openSuccessModal && (
            <MessageModal
              open={openSuccessModal}
              setOpen={setOpenSuccessModal}
              message={`${t("roleManagement.theRole")} ${deletingRole?.name} ${t("roleManagement.hasBeenDeleted")}`}
              onClose={() => setOpenSuccessModal(false)}
            />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};
